import { IUser } from "@Common/interfaces/user";
import { IRecordPositionUser } from "@Common/helpers/Positions/interfaces";
import { TUserPositionRecord } from "@Common/helpers/Positions/types";

import POSITIONS from "@Constants/positions";

const getSubPosition = (position: string, isNew = false) => {
	if (isNew) {
		return `${position} New`;
	}
	return `${position} Pre-owned`;
};

const MUTABLE_POSITIONS = [POSITIONS.FINANCE.FINANCE_DIRECTOR, POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE];

const ADVISORS_POSITIONS = [
	POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR,
	POSITIONS.SERVICE.SERVICE_ADVISOR,
	POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR,
];

const TECHNICIAN_POSITIONS = [
	POSITIONS.SERVICE.SERVICE_TECHNICIAN,
	POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN,
	POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER,
];

const PRODUCER_POSITIONS = [
	POSITIONS.SALES.SALES_ASSOCIATE,
	POSITIONS.FINANCE.FINANCE_MANAGER,
	POSITIONS.BDC.BDC_SALES_ASSOCIATE,
	POSITIONS.BDC.BDC_SERVICE_ASSOCIATE,
	POSITIONS.SERVICE.SERVICE_ADVISOR,
	POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR,
	POSITIONS.SERVICE.SERVICE_TECHNICIAN,
	POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR,
	POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN,
	POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER,
	"Finance Director Producer", // TODO: Add better way to handle this
];

const DEPARTMENTS = new Map([
	// Corporate Department
	[POSITIONS.LOCATION.GENERAL_MANAGER, "Corporate"],
	// Sales Department
	[POSITIONS.SALES.SALES_ASSOCIATE, "Sales"],
	[getSubPosition(POSITIONS.SALES.SALES_ASSOCIATE, true), "Sales"],
	[getSubPosition(POSITIONS.SALES.SALES_ASSOCIATE), "Sales"],
	[POSITIONS.SALES.SALES_MANAGER, "Sales"],
	[getSubPosition(POSITIONS.SALES.SALES_MANAGER, true), "Sales"],
	[getSubPosition(POSITIONS.SALES.SALES_MANAGER), "Sales"],
	[POSITIONS.SALES.GENERAL_SALES_MANAGER, "Sales"],
	// Finance Department
	[POSITIONS.FINANCE.FINANCE_MANAGER, "Finance"],
	[POSITIONS.FINANCE.FINANCE_DIRECTOR, "Finance"],
	// BDC Department
	[POSITIONS.BDC.BDC_SALES_ASSOCIATE, "BDC"],
	[POSITIONS.BDC.BDC_SERVICE_ASSOCIATE, "BDC"],
	[POSITIONS.BDC.BDC_MANAGER, "BDC"],
	// Body Shop Department
	[POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER, "Body Shop"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER, "Body Shop"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN, "Body Shop"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER, "Body Shop"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR, "Body Shop"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN, "Body Shop"],
	// Service Department
	[POSITIONS.SERVICE.SERVICE_MANAGER, "Service"],
	[POSITIONS.SERVICE.SERVICE_TECHNICIAN, "Service"],
	[POSITIONS.SERVICE.SERVICE_ADVISOR, "Service"],
	[POSITIONS.SERVICE.SERVICE_DIRECTOR, "Service"],
	[POSITIONS.SERVICE.SERVICE_FOREMAN, "Service"],
	[POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR, "Service"],
	// Parts Department
	[POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE, "Parts"],
	[POSITIONS.PARTS.PARTS_MANAGER, "Parts"],
	[POSITIONS.PARTS.PARTS_DIRECTOR, "Parts"],
]);

const DEPARTMENTAL = new Map([
	// SALES
	["SALES ASSOCIATE", POSITIONS.SALES.SALES_ASSOCIATE],
	["SALES ASSOCIATES", POSITIONS.SALES.SALES_ASSOCIATE],
	["SALES ASSOCIATE NEW", POSITIONS.SALES.SALES_ASSOCIATE],
	["SALES ASSOCIATE PRE-OWNED", POSITIONS.SALES.SALES_ASSOCIATE],
	["SALES ASSOCIATE PRE-OWNED", POSITIONS.SALES.SALES_ASSOCIATE],
	["SALES CONSULTANT", POSITIONS.SALES.SALES_ASSOCIATE],
	["SALES MANAGER", POSITIONS.SALES.SALES_MANAGER],
	["SALES MANAGERS", POSITIONS.SALES.SALES_MANAGER],
	["SALES MANAGER NEW", POSITIONS.SALES.SALES_MANAGER],
	["SALES MANAGER PRE-OWNED", POSITIONS.SALES.SALES_MANAGER],
	["GENERAL SALES MANAGER", POSITIONS.SALES.GENERAL_SALES_MANAGER],
	["GENERAL SALES MANAGERS", POSITIONS.SALES.GENERAL_SALES_MANAGER],
	// FINANCE
	["F&I MANAGER", POSITIONS.FINANCE.FINANCE_MANAGER],
	["FINANCE MANAGER", POSITIONS.FINANCE.FINANCE_MANAGER],
	["FINANCE MANAGERS", POSITIONS.FINANCE.FINANCE_MANAGER],
	["FINANCE DIRECTOR", POSITIONS.FINANCE.FINANCE_DIRECTOR],
	// BDC
	["BDC SALES ASSOCIATE", POSITIONS.BDC.BDC_SALES_ASSOCIATE],
	["BDC SALES ASSOCIATES", POSITIONS.BDC.BDC_SALES_ASSOCIATE],
	["BDC SERVICE ASSOCIATE", POSITIONS.BDC.BDC_SERVICE_ASSOCIATE],
	["BDC SERVICE ASSOCIATES", POSITIONS.BDC.BDC_SERVICE_ASSOCIATE],
	["BDC MANAGER", POSITIONS.BDC.BDC_MANAGER],
	["BDC MANAGERS", POSITIONS.BDC.BDC_MANAGER],
	// BODY SHOP
	["BODY SHOP MANAGER", POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER],
	["BODY SHOP MANAGERS", POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER],
	["BODY SHOP PRODUCT MANAGER", POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER],
	["BODY SHOP PRODUCT MANAGERS", POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER],
	["BODY SHOP TECHNICIAN", POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN],
	["BODY SHOP TECHNICIANS", POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN],
	["BODY SHOP PAINTER", POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER],
	["BODY SHOP PAINTERS", POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER],
	["BODY SHOP ESTIMATOR", POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR],
	["BODY SHOP ESTIMATORS", POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR],
	["BODY SHOP FOREMAN", POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN],
	["BODY SHOP FOREMANS", POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN],
	// SERVICE
	["SERVICE MANAGER", POSITIONS.SERVICE.SERVICE_MANAGER],
	["SERVICE MANAGERS", POSITIONS.SERVICE.SERVICE_MANAGER],
	["SERVICE TECHNICIAN", POSITIONS.SERVICE.SERVICE_TECHNICIAN],
	["SERVICE TECHNICIANS", POSITIONS.SERVICE.SERVICE_TECHNICIAN],
	["SERVICE ADVISOR", POSITIONS.SERVICE.SERVICE_ADVISOR],
	["SERVICE ADVISORS", POSITIONS.SERVICE.SERVICE_ADVISOR],
	["SERVICE DIRECTOR", POSITIONS.SERVICE.SERVICE_DIRECTOR],
	["SERVICE DIRECTORS", POSITIONS.SERVICE.SERVICE_DIRECTOR],
	["SERVICE FOREMAN", POSITIONS.SERVICE.SERVICE_FOREMAN],
	["SERVICE FOREMANS", POSITIONS.SERVICE.SERVICE_FOREMAN],
	["INTERNAL SERVICE ADVISOR", POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR],
	["INTERNAL SERVICE ADVISORS", POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR],
	// PARTS
	["PARTS COUNTER ASSOCIATE", POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE],
	["PARTS COUNTER ASSOCIATES", POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE],
	["PARTS MANAGER", POSITIONS.PARTS.PARTS_MANAGER],
	["PARTS MANAGERS", POSITIONS.PARTS.PARTS_MANAGER],
	["PARTS DIRECTOR", POSITIONS.PARTS.PARTS_DIRECTOR],
	["PARTS DIRECTORS", POSITIONS.PARTS.PARTS_DIRECTOR],
]);

const FAMILY_IDENTIFIERS = new Map([
	// SALES
	[POSITIONS.SALES.SALES_ASSOCIATE, "SALES"],
	[POSITIONS.SALES.SALES_MANAGER, "SALES_DEPARTMENTAL"],
	[POSITIONS.SALES.GENERAL_SALES_MANAGER, "SALES_DEPARTMENTAL"],
	// FINANCE
	[POSITIONS.FINANCE.FINANCE_MANAGER, "FINANCE"],
	[POSITIONS.FINANCE.FINANCE_DIRECTOR, "SALES_DEPARTMENTAL"],
	// BDC
	[POSITIONS.BDC.BDC_SALES_ASSOCIATE, "BDC"],
	[POSITIONS.BDC.BDC_SERVICE_ASSOCIATE, "BDC"],
	[POSITIONS.BDC.BDC_MANAGER, "BDC"],
	// BODY SHOP
	[POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN, "TECHNICIANS"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER, "TECHNICIANS"],
	[POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR, "ADVISORS"],
	// SERVICE
	[POSITIONS.SERVICE.SERVICE_MANAGER, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.SERVICE.SERVICE_DIRECTOR, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.SERVICE.SERVICE_FOREMAN, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.SERVICE.SERVICE_TECHNICIAN, "TECHNICIANS"],
	[POSITIONS.SERVICE.SERVICE_ADVISOR, "ADVISORS"],
	[POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR, "ADVISORS"],
	// PARTS
	[POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.PARTS.PARTS_MANAGER, "SERVICE_DEPARTMENTAL"],
	[POSITIONS.PARTS.PARTS_DIRECTOR, "SERVICE_DEPARTMENTAL"],
]);

function positionStatusMapper(positionStatus: string) {
	switch (positionStatus) {
		case "ACTIVE":
			return "Active";
		case "CLOSING":
			return "Closing";
		case "REVIEWING":
			return "Reviewing";
		case "APPROVED":
			return "Approved";
		case "UNREVIEWABLE":
			return "Unreviewable";
		case "POSTED_PAYROLL":
			return "Posted to Payroll";
		default:
	}

	return "";
}

function matchPositions(position: string) {
	switch (position) {
		case "Sales Associate Pre-owned":
			return "Sales Associate Used";
		case "Sales Manager Pre-owned":
			return "Sales Manager Used";
		case "Body Shop Product Manager":
			return "Body Shop Prod. Mgr.";
		default:
			break;
	}

	return position;
}

const transformToUpperCase = (value = "") => String(value)?.trim()?.toUpperCase();

const normalizePositions = (position: string) => getDepartmentalPosition(position);

const supportedSystemPositions = () => POSITIONS;

const isDrawablePosition = (positionDrawModality: string) => transformToUpperCase(positionDrawModality) !== "COMMISSION ONLY (NO DRAW)";

const isMutablePosition = (position: string) => {
	const departmentalPosition = getDepartmentalPosition(position);
	return MUTABLE_POSITIONS.some((item) => item === departmentalPosition);
};

const getListSystemPositions = () => {
	return [
		POSITIONS.SALES.SALES_ASSOCIATE,
		POSITIONS.SALES.SALES_MANAGER,
		POSITIONS.SALES.GENERAL_SALES_MANAGER,
		POSITIONS.FINANCE.FINANCE_MANAGER,
		POSITIONS.FINANCE.FINANCE_DIRECTOR,
		POSITIONS.BDC.BDC_SALES_ASSOCIATE,
		POSITIONS.BDC.BDC_SERVICE_ASSOCIATE,
		POSITIONS.BDC.BDC_MANAGER,
		POSITIONS.BODY_SHOP.BODY_SHOP_MANAGER,
		POSITIONS.BODY_SHOP.BODY_SHOP_PRODUCT_MANAGER,
		POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN,
		POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER,
		POSITIONS.BODY_SHOP.BODY_SHOP_ESTIMATOR,
		POSITIONS.BODY_SHOP.BODY_SHOP_FOREMAN,
		POSITIONS.SERVICE.SERVICE_MANAGER,
		POSITIONS.SERVICE.SERVICE_TECHNICIAN,
		POSITIONS.SERVICE.SERVICE_ADVISOR,
		POSITIONS.SERVICE.SERVICE_DIRECTOR,
		POSITIONS.SERVICE.SERVICE_FOREMAN,
		POSITIONS.SERVICE.INTERNAL_SERVICE_ADVISOR,
		POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE,
		POSITIONS.PARTS.PARTS_MANAGER,
		POSITIONS.PARTS.PARTS_DIRECTOR,
	];
};

const getDepartmentalPosition = (position: string) => {
	const upperPosition = transformToUpperCase(position);
	return DEPARTMENTAL.get(upperPosition) ?? position;
};

const getPositionKey = (position: string): string => {
	const departmentalPosition = getDepartmentalPosition(position);

	for (const department of Object.values(POSITIONS)) {
		for (const [key, value] of Object.entries(department)) {
			if (value === departmentalPosition) {
				return key;
			}
		}
	}

	return departmentalPosition?.toUpperCase()?.replace(/\s+/g, "_") || "";
};

const getPositionDepartment = (position: string) => {
	if (!position) {
		return "Unknown";
	}
	const departmentalPosition = getDepartmentalPosition(position);
	return DEPARTMENTS.get(departmentalPosition) ?? "Unknown";
};

/**
 * Returns the list of positions based on the departments.
 * @param {string[]} departments - List of departments.
 * @param {boolean} rawOnly - If true, removes " New" and " Pre-owned" suffixes from positions.
 * @returns {string[]} - List of positions that belong to the departments.
 */
const getPositionsByDepartments = (departments: string[], rawOnly = false): string[] => {
	const positions = [];
	for (const [position, dept] of DEPARTMENTS) {
		if (departments.includes(dept)) {
			positions.push(position);
		}
	}
	return rawOnly ? getRawPositions(positions) : positions;
};

export const getRawPositions = (positions: string[]): string[] => {
	const rawPositions = positions.map((position) => position.replace(/ New$| Pre-owned$/g, ""));
	return Array.from(new Set(rawPositions)).filter(Boolean);
}

const getTechniciansPositions = () => TECHNICIAN_POSITIONS;
const getAdvisorsPositions = () => ADVISORS_POSITIONS;

// Also previously known as getSpiffDepartment
const getDepartmentHierarchy = (position: string) => {
	const departmental = getDepartmentalPosition(position);
	if (TECHNICIAN_POSITIONS.includes(departmental)) {
		return "Service";
	}
	return "Sales";
};

export const SALES_DEPARTMENTS = ["Sales", "Finance"];
export const SERVICE_DEPARTMENTS = ["Service", "Body Shop", "Parts"];

const getPositionType = (position?: string) => {
	if (!position) {
		return "";
	}
	const department = DEPARTMENTS.get(normalizePositions(position)) ?? "";
	if (SALES_DEPARTMENTS.includes(department)) {
		return "Sales";
	}
	if (SERVICE_DEPARTMENTS.includes(department)) {
		return "Service";
	}
	return "HQ";
};

const getPositionFamilyIdentifier = (position: string) => {
	const departmental = getDepartmentalPosition(position);
	return FAMILY_IDENTIFIERS.get(departmental) ?? "UNKNOWN";
};

const getMutableFamily = (position: string, isDepartmental = false) => {
	switch (position) {
		case POSITIONS.FINANCE.FINANCE_DIRECTOR:
			if (!isDepartmental) {
				return "FINANCE";
			}
			return "SALES_DEPARTMENTAL";
		case POSITIONS.PARTS.PARTS_COUNTER_ASSOCIATE:
			// TODO: Implement this position when needed
			return "SERVICE_DEPARTMENTAL";
		default:
			break;
	}
	return "UNKNOWN";
};

const getPositionFamily = (position: string, isDepartmental = false) => {
	const departmental = getDepartmentalPosition(position);
	const isMutable = isMutablePosition(position);
	if (isMutable) {
		return getMutableFamily(departmental, isDepartmental);
	}
	return getPositionFamilyIdentifier(departmental);
};

/**
 * @name groupUsersByPosition
 * @description Groups users by their position
 * @param {Array} users
 * @returns {Array} usersGroupedByPosition
 */
const groupUsersByPosition = (users: IUser[]): IRecordPositionUser[] => {
	const groupBy = (acc: IUser[], item: string) => {
		return acc.reduce((rv: TUserPositionRecord, x: IUser): TUserPositionRecord => {
			const key = x[item as keyof IUser];
			rv[key as keyof TUserPositionRecord] = rv[key as keyof TUserPositionRecord] || [];
			rv[key as keyof TUserPositionRecord].push(x);
			return rv;
		}, {} as TUserPositionRecord);
	};

	const payload = [];

	for (const [key, value] of Object.entries(groupBy(users, "position"))) {
		payload.push({
			position: key,
			users: value,
		});
	}

	return payload;
};

const isProducerPosition = (position: string) => {
	const departmentalPosition = getDepartmentalPosition(position);
	return PRODUCER_POSITIONS.includes(departmentalPosition);
};

export {
	isDrawablePosition,
	isMutablePosition,
	isProducerPosition,
	getDepartmentalPosition,
	getPositionKey,
	getPositionDepartment,
	getDepartmentHierarchy,
	matchPositions,
	normalizePositions,
	positionStatusMapper,
	supportedSystemPositions,
	getListSystemPositions,
	getPositionsByDepartments,
	getTechniciansPositions,
	getAdvisorsPositions,
	groupUsersByPosition,
	getPositionFamily,
	getPositionFamilyIdentifier,
	getPositionType,
	getSubPosition,
};
